import(/* webpackMode: "eager" */ "/vercel/path0/src/app/terms/page.js");
